import {definePreset} from '@primeng/themes';
import Aura from '@primeng/themes/aura';

export const BackendPreset = definePreset(Aura, {
  primitive: {
    white: {
      500: '#fff'
    },
    accent: {
      50:  '#e6f5fb', // sehr hell – fast weiß, für Hintergründe
      100: '#bde4f5', // hell – Hover-Effekt, Sekundärelemente
      200: '#8dd0ec', // weich – Linien, Icons, passive States
      300: '#5cbbe3', // leicht betont
      400: '#2ca6d9', // aktiv, hellere Buttons
      500: '#1586bf', // dein Primärton – Standard
      600: '#116fa2', // dunkler – Hover/Fokus
      700: '#0e5c87', // kräftiger – aktive Buttons, Links
      800: '#0b496b', // sehr dunkel – Header, Akzentflächen
      900: '#083752', // fast navy – tiefer Kontrast
    },
    /*accent: {
      50:  '#e6f7fd',
      100: '#bce7fb',
      200: '#8bd6f9',
      300: '#5ac4f7',
      400: '#2fb0f3',
      500: '#1BA0E0',
      600: '#1586bf',
      700: '#116699',
      800: '#0c4b73',
      900: '#07314d',
      950: '#031927'
    },*/
    anthrazit: {
      50:  '#f8fafc',
      100: '#f1f5f9',
      200: '#e2e8f0',
      300: '#cbd5e1',
      400: '#94a3b8',
      500: '#475569',
      600: '#374151',
      700: '#303742',
      800: '#1e293b',
      900: '#0f172a',
      950: '#020617'
    },
    grau: {
      50: '#fcfcfc',
      100: '#fafafa',
      200: '#f5f5f5',
      300: '#ededed',
      400: '#e8e8e8',
      500: '#e3e3e3',
      600: '#b5b5b5',
      700: '#878787',
      800: '#5c5c5c',
      900: '#2e2e2e',
      950: '#171717'
    }
  },
  semantic: {
    textColor: {
      500: '{white.500}'
    },
    inputTextColor: {
      500: '#000000de'
    },
    primary: {
      50: '{accent.50}',
      100: '{accent.100}',
      200: '{accent.200}',
      300: '{accent.300}',
      400: '{accent.400}',
      500: '{accent.500}',
      600: '{accent.600}',
      700: '{accent.700}',
      800: '{accent.800}',
      900: '{accent.900}',
      950: '{accent.950}'
    },
    primaryColor: {
      500: '#ffffff'
    },
    secondaryColor: {
      500: '#ffffff'
    },
    secondaryBackground: {
      50:  '#f8fafc',
      100: '#f1f5f9',
      200: '#e2e8f0',
      300: '#cbd5e1',
      400: '#94a3b8',
      500: '#475569',
      600: '#374151',
      700: '#303742',
      800: '#1e293b',
      900: '#0f172a',
      950: '#020617'
    },
    grayBackground: {
      50:  '#c8c8c8', // leicht hellgrau, aber nicht weiß
      100: '#a0a0a0', // neutrales Grau
      200: '#828282', // leicht dunkler
      300: '#6a6a6a', // mittleres Grau
      400: '#4a4a4a', // sanfter Übergang vor 500
      500: '#3a3a3a', // dein Basisgrau (etwas heller als #333)
      600: '#2f2f2f', // minimal dunkler – Hover/aktive Zustände
      700: '#242424', // sehr dunkel – Navigationshintergrund
      800: '#191919', // fast schwarz – App-Hintergrund
      900: '#0f0f0f', // tiefstes Grau – Footer/Modal-Hintergrund
    },
    purple: {
      50: '#faf4fb',
      100: '#e7cbec',
      200: '#d4a2dd',
      300: '#c279ce',
      400: '#af50bf',
      500: '#9c27b0',
      600: '#852196',
      700: '#6d1b7b',
      800: '#561561',
      900: '#3e1046'
    },
    green: {
      50:  '#e5f6e8', // sehr hell – Success-Hintergrund im Light Theme
      100: '#bde8c2', // weich, hellgrün
      200: '#8fdc99', // hell, freundlich – sekundäre Elemente
      300: '#5fcc70', // lebendig, frisch
      400: '#36b84c', // kräftig, für aktive Zustände
      500: '#00aa00', // dein Basisgrün – Primär Success-Ton
      600: '#258A37', // etwas dunkler – Hover/Active
      700: '#1e6e2d', // tiefgrün – Dark Theme oder Schatten
      800: '#145020', // satt, fast waldgrün
      900: '#0b3213', // sehr dunkel – Kontrastfarbe
    },
    red: {
      50:  '#f9e6e6', // sehr hell – dezenter Hintergrund für Light Themes
      100: '#f2bfbf', // weich, fast rosé
      200: '#e68080', // hellrot – Icons, sekundäre Fehlerhinweise
      300: '#d94d4d', // kräftiger, aber nicht grell
      400: '#c91f1f', // intensiver – Hover, Fokus
      500: '#B60000', // dein Hauptrot – Primärton für Fehler/Alert
      600: '#9a0000', // dunkler – Hover/Active
      700: '#7f0000', // tiefrot – Dark Theme
      800: '#5c0000', // fast weinrot
      900: '#3a0000', // sehr dunkel – Text oder Border auf hellen Flächen
    },
  },
  components: {
    panel: {
      border: {
        color: '{slate.200}'
      }
    },
    inputtext: {
      color: '{inputTextColor.500}',
      border: {
        color: 'rgba(0, 0, 0, .38)',
        radius: '4px'
      },
      invalid: {
        border: {
          color: '#b00020'
        }
      }
    },
    message: {
      colorScheme: {
        info: {
          background: '{accent.100}',
          color: '{accent.800}'
        },
        warn: {
          background: '{orange.100}',
          color: '{orange.800}'
        },
        error: {
          background: '{red.100}',
          color: '{red.600}'
        }
      }
    },
    toast: {
      colorScheme: {
        info: {
          background: '{accent.100}',
          color: '{accent.800}'
        },
        warn: {
          background: '{orange.100}',
          color: '{orange.800}'
        },
        error: {
          background: '{red.100}',
          color: '{red.600}'
        }
      }
    },
    button: {
      root: {
        background: '{primary.500}'
      },
      colorScheme: {
        secondary: {
          color: '{secondaryColor.500}',
          background: '{secondaryBackground.500}',
          focus: {
            background: '{secondaryBackground.500}'
          },
          active: {
            color: '{secondaryColor.500}',
            background: '{secondaryBackground.500}'
          },
          hover: {
            color: '{secondaryColor.500}',
            background: '{secondaryBackground.400}'
          }
        },
      },
    },
    togglebutton: {
      colorScheme: {
        content: {
          checked: {
            background: '{primary.600}',
          }
        },
        checked: {
          color: '{textColor.500}',
        }
      }
    },
    select: {
      color: '{inputTextColor.500}',
      border: {
        color: 'rgba(0, 0, 0, .38)',
        radius: '4px'
      },
      dropdown: {
        color: '#0009'
      },
      option: {
        selected: {
          color: '{inputTextColor.500}',
          focus: {
            background: '{secondaryBackground.200}',
            color: '{inputTextColor.500}'
          }
        },
      }
    },
    multiselect: {
      color: '{inputTextColor.500}',
      border: {
        color: 'rgba(0, 0, 0, .38)',
        radius: '4px'
      },
      dropdown: {
        color: '#0009'
      },
      /*option: {
        selected: {
          color: '{inputTextColor.500}',
          focus: {
            background: '{secondaryBackground.200}',
            color: '{inputTextColor.500}'
          }
        },
      }*/
    },
    menubar: {
      background: '{grayBackground.500}',
      color: '#ffffff',
      /*root: {
        padding: '0.5rem',
      },*/
      item: {
        color: '#ffffff',
        icon: {
          color: '#ffffff',
          focus: {
            color: 'var(--accent)'
          }
        },
        label: {
          color: '#ffff00 !important',
          'white-space': 'nowrap',
          focus: {
            color: '{blau.600}',
          }
        },
        focus: {
          background: '#00416F',
          color: '#ffffff',
        },
        active: {
          color: '#ffffff'
        },
        subtitle: {
          color: '#ffffff'
        }
      },
      submenu: {
        background: '{grayBackground.500}',
        color: '#ffffff',
        icon: {
          color: '#ffffff',
          focus: {
            color: 'var(--accent)'
          },
          active: {
            color: '#ffffff'
          }
        }
      },
      subtitle: {
        color: '#ffffff'
      },
      base: {
        item: {
          padding: '0.5rem 0.6rem'
          /* 0.5rem 0.75rem; */
        }
      }
    },
    divider: {
      border: {
        color: 'rgba(0, 0, 0, .12)'
      }
    },
    datatable: {
      colorScheme: {
        row: {
          color: '#000000de'
        }
      }
    },
    datepicker: {
      colorScheme: {
        dropdown: {
          background: '{primary.500}',
          color: '{textColor.500}',
          border: {
            color: '{primary.500}',
          },
          hover: {
            background: '{primary.600}',
            color: '{textColor.500}',
            border: {
              color: '{primary.600}',
            }
          }
        }
      }
    },
    autocomplete: {
      colorScheme: {
        dropdown: {
          background: '{primary.500}',
          color: '{textColor.500}',
          border: {
            color: '{primary.500}',
          },
          hover: {
            background: '{primary.600}',
            color: '{textColor.500}',
            border: {
              color: '{primary.600}',
            }
          }
        }
      }
    },
    // --p-stepper-step-number-active-background
    stepper: {
      colorScheme: {
        step: {
          number: {
            active: {
              background: '{primary.600}',
              color: '{primaryColor.500}',
            }
          }
        }
      }
    }

    /*datatable: {
      colorScheme: {
        row: {
          striped: {
            background: '#00000005'
          }
        }
      }
    }*/
    /*.p-breadcrumb .p-breadcrumb-list li:last-child .p-menuitem-text {
    color: #000000de;
}*/
  }
});
